/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHideBezel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 22H4V8h2v12h12v-7h2zm-6-4h-4v-2h4zm6-7h-2V8h2zm0-5h-2V4h-2V2h4zM6 6H4V2h4v2H6zm8-2h-4V2h4z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgHideBezel as HideBezel };
